import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';

import { FlexView, Row, Separator } from '@cuemath/comps';
import Search from 'modules/list/search-bar';
import Pagination from 'modules/list/pagination';
import { RESULTS_PER_PAGE } from 'constants/list';

import { getAll as getApplicantList } from 'actions/applicant-list';
import ApplicantsTable from './list';

const FullFlexView = styled(FlexView)`
  width: 100%;
`;

const Head = styled(Row)`
  width: 100%;
  padding-left: 16px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const TeacherApplicantsTab = ({ actions, teacherApplicantList }) => {
  const firstPage = 1;
  const [searchKey, setSearchKey] = useState(null);
  const [page, setPage] = useState(firstPage);
  const [applicantList, setApplicantList] = useState([]);

  useEffect(() => {
    actions.getApplicantList();
  }, []);

  useEffect(() => {
    const applicantList = store.getAll(teacherApplicantList);
    const { isLoaded, data } = applicantList || {};
    if (applicantList && isLoaded) {
      setApplicantList(data);
    }
  }, [teacherApplicantList]);

  const onPageChange = useCallback(
    newPage => {
      if (newPage !== page) {
        setPage(newPage);

        const filterData = {};
        filterData.page = newPage;
        filterData.per_page = RESULTS_PER_PAGE;
        actions.getApplicantList({}, filterData);
      }
    },
    [page],
  );

  const onSearch = useCallback(
    newSearchKey => {
      if (newSearchKey !== searchKey) setSearchKey(newSearchKey);
      setPage(firstPage);
      const filterData = {};
      filterData.search = newSearchKey;
      actions.getApplicantList({}, filterData);
    },
    [searchKey],
  );

  return (
    <FullFlexView justifyContent="center" alignItems="center">
      <Head>
        <Search placeholder="Search applicant by phone or id..." onSearch={onSearch} />
        <Separator transparent height="6" />
      </Head>
      <ApplicantsTable applicants={applicantList} onPageChange={onPageChange} />
      <Pagination page={page} perPage={RESULTS_PER_PAGE} onPageChange={onPageChange} />
    </FullFlexView>
  );
};

export default connect(
  ({ teacherApplicantList }) => ({
    teacherApplicantList,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getApplicantList,
      },
      dispatch,
    ),
  }),
)(TeacherApplicantsTab);
